module.exports = __webpack_public_path__ + "img/SYM06.00b5918c.gif";